<section class="row mx-3">
  <p-card class="col-12 col-xl-6 ms-xl-3 mb-3" header="Cambiar contraseña">
    <h5>Tu contraseña ha expirado. Para continuar, debes establecer una nueva.</h5>
    <form [formGroup]="passwordForm">
      <p-floatlabel class="my-3 d-block password-field" variant="in">
        <p-iconfield>
          <!-- <p-inputicon class="pi pi-lock" /> -->

          <input
            pInputText
            [type]="showCPassword ? 'text' : 'password'"
            id="password"
            class="w-100"
            formControlName="currentPassword"
            autocomplete="current-password"
          />

          <p-inputicon>
            <p-button
              [icon]="showCPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
              [text]="true"
              [rounded]="true"
              severity="secondary"
              (onClick)="showCPassword = !showCPassword"
              type="button"
            />
          </p-inputicon>
        </p-iconfield>
        <label for="password">Contraseña actual</label>
      </p-floatlabel>

      <p-floatlabel class="my-3 d-block password-field" variant="in">
        <p-iconfield>
          <!-- <p-inputicon class="pi pi-lock" /> -->

          <input
            pInputText
            [type]="showPassword ? 'text' : 'password'"
            id="new-password"
            class="w-100"
            formControlName="newPassword"
            autocomplete="new-password"
          />

          <p-inputicon>
            <p-button
              [icon]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
              [text]="true"
              [rounded]="true"
              severity="secondary"
              (onClick)="showPassword = !showPassword"
              type="button"
            />
          </p-inputicon>
        </p-iconfield>
        <label for="new-password">Contraseña nueva</label>
      </p-floatlabel>

      <p-floatlabel class="my-3" variant="in">
        <p-iconfield>
          <input
            pInputText
            type="password"
            id="repeat-password"
            class="w-100"
            formControlName="repeatPassword"
            autocomplete="new-password"
          />
        </p-iconfield>
        <label for="repeat-password">Repetir contraseña nueva</label>
      </p-floatlabel>

      @if (error) {
        <p-message styleClass="mb-3" severity="error">{{ error }}</p-message>
      }

      <div class="d-flex flex-column gap-2 w-100">
        <p-button
          fluid="true"
          class="w-100"
          [disabled]="passwordForm.invalid"
          (onClick)="changePassword()"
          label="Cambiar contraseña"
        ></p-button>
        <p-button
          type="button"
          severity="secondary"
          outlined="true"
          label="Volver a inicio de sesión"
          styleClass="login-register"
          (onClick)="backToLogin()"
          class="w-100"
          [style]="{ width: '100%' }"
        />
      </div>
    </form>
  </p-card>

  <p-card header="Requisitos" class="col-12 col-xl-4 ms-xl-3 mb-3">
    <div class="password-hints mb-3">
      <small [class.text-success]="passErrors.hasMinLength" class="d-block my-2">
        <i class="pi" [ngClass]="passErrors.hasMinLength ? 'pi-check' : 'pi-times'"></i>
        Mínimo 8 caracteres
      </small>

      <small [class.text-success]="passErrors.hasMaxLength" class="d-block mb-2">
        <i class="pi" [ngClass]="passErrors.hasMaxLength ? 'pi-check' : 'pi-times'"></i>
        Máximo 10 caracteres
      </small>

      <small [class.text-success]="passErrors.hasUpper" class="d-block mb-2">
        <i class="pi" [ngClass]="passErrors.hasUpper ? 'pi-check' : 'pi-times'"></i>
        Una mayúscula
      </small>

      <small [class.text-success]="passErrors.hasLower" class="d-block mb-2">
        <i class="pi" [ngClass]="passErrors.hasLower ? 'pi-check' : 'pi-times'"></i>
        Una minúscula
      </small>

      <small [class.text-success]="passErrors.hasNumber" class="d-block mb-2">
        <i class="pi" [ngClass]="passErrors.hasNumber ? 'pi-check' : 'pi-times'"></i>
        Un número
      </small>

      <small [class.text-success]="passErrors.hasSymbol" class="d-block mb-2">
        <i class="pi" [ngClass]="passErrors.hasSymbol ? 'pi-check' : 'pi-times'"></i>
        Un símbolo
      </small>

      <small [class.text-success]="passwordsMatch" class="d-block mb-2">
        <i class="pi" [ngClass]="passwordsMatch ? 'pi-check' : 'pi-times'"></i>
        Las contraseñas coinciden
      </small>
    </div>
  </p-card>
</section>
